module.exports = __webpack_public_path__ + "media/bootstrap-icons/ui-checks-182344c5.svg";